import {createContext} from 'react'

export type SessionContextType = {
    getItem: (key: string) => string | null
    setItem: (key: string, value: string) => void
}
export const SessionContext = createContext<SessionContextType>({} as SessionContextType)
